import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { useAuth, Roles } from "../../providers/AuthContext";
import { createAccessGroup } from "../../api/AccessGroups"; // Import API function
import toast from "react-hot-toast";
import LoadingTablePage from "../LoadingTablePage";
import AccessGroupForm from "../../components/accessGroup/AccessGroupForm";

const CreateAccessGroupsPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { customerPublicId } = location.state || {};
  const { getAccessToken, hasRole } = useAuth(); // Get the access accessGroup from context
  const [customers] = useState([]);
  const navigate = useNavigate();
  const [loading] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);

  // Define initial state for the form
  const [accessGroup, setAccessGroup] = useState({
    name: "",
    description: "",
    hasUniversalSiteAccess: false,
  });

  // Handler for form input changes
  const handleInputChange = (key, value) => {
    setHasChanges(true);
    setAccessGroup((prev) => ({ ...prev, [key]: value }));
  };

  // Form submission handler
  const handleCreateAccessGroup = async () => {
    const toastId = toast.loading(t("toast.creating", { entity: t("entity.accessGroup") }));

    try {
      const accessAccessGroup = await getAccessToken();
      const newAccessGroup = await createAccessGroup(accessGroup, accessAccessGroup); // Make the API call to create a site

      toast.success(t("toast.created", { entity: t("entity.accessGroup") }), { id: toastId });

      if(customerPublicId) {
        navigate(`/accessGroup/${newAccessGroup.accessGroupPublicId}`, { state: { customerPublicId: customerPublicId  } });
      } else {
        navigate(`/accessGroup/${newAccessGroup.accessGroupPublicId}`);
      }
    } catch (error) {
      toast.error(error?.message, {
        id: toastId,
      });
    }
  };


  const navigateBack = () => {
    if(customerPublicId) {
      navigate(`/customer/${customerPublicId}?tab=accessGroups`);
    } else {
      if (navigate.length > 1) {
        navigate(-1);
      } else {
        navigate("/accessGroups");
      }
    } 
  }

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="absolute inset-0 pointer-events-none">
            <LoadingTablePage title={t("pages.createAccessGroup")} loading={loading} />
          </div>

          <div className={`${loading ? "loading" : ""} page-content`}>
            <div className="flex flex-row items-center pb-4">
              <button
                onClick={() => navigateBack()}
                className="text-black flex"
              >
                <FontAwesomeIcon icon={faArrowLeft} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4 ">{t("pages.createAccessGroup")}</h2>
              <div className="flex gap-4 ml-auto">
                <button
                  className="btn btn-outline-primary"
                  onClick={() => navigateBack()}
                >
                  {t("common.cancel")}
                </button>
                <button
                  className="btn btn-primary"
                  disabled={!accessGroup?.name && !hasChanges}
                  onClick={handleCreateAccessGroup}
                >
                  {t("common.save")}
                </button>
              </div>
            </div>

            {/* Charging site form */}
            <div className=" px-4 py-8 shadow-lg rounded-md w-full">
                <AccessGroupForm
                  accessGroup={accessGroup}
                  handleInputChange={handleInputChange}
                  showGlobalAccess={hasRole(Roles.Admin)}
                  showOrganizationName={false}
                  customers={customers}
                />
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default CreateAccessGroupsPage;
